import { render } from "./ResearchTab.vue?vue&type=template&id=1d11d7b2&scoped=true"
import script from "./ResearchTab.vue?vue&type=script&lang=js"
export * from "./ResearchTab.vue?vue&type=script&lang=js"

import "./ResearchTab.vue?vue&type=style&index=0&id=1d11d7b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d11d7b2"]])

export default __exports__